// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"470f18f3","814":"9be7cca8"}[chunkId] + ".chunk.js";
};